<script>
import { required } from 'vuelidate/lib/validators'

// import appConfig from '@src/app.config'

import axios from 'axios'
import Files from './files'
import Alerts from './alerts'
import Assets from './assets'
import NetInfos from './netinfos'
import SearchInput from '@components/search-input.vue'
import SearchDateTime from '@components/search-datetime.vue'

// import * as d3 from "d3"

export default {
  components: {
    Files,
    Alerts,
    Assets,
    NetInfos,
    SearchInput,
    SearchDateTime,
  },
  props: {
    url: {
      type: String,
      default: '/pan/xdr/incidents',
    },
  },
  data() {
    return {
      appConfig: {},
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Incidents View',
          active: true,
        },
      ],
      appConfig:
        process.env.NODE_ENV === 'production'
          ? require('@src/app.config')
          : require('@src/app.config.dev'),
      incident: {},
      incident_fa: {},
      incident_na: {},
      assets: [],
      netinfo: [],
      indicatorsFile: {},
      indicatorsNet: {},
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: '',
      // filterOn: [],
      sortBy: 'incident_id',
      sortDesc: true,
      searchFields: '',
      showSearchByFields: true, // Cambiar a true para activar cambio de filtrado
      showDownloadCSVButton: true,
      tableDetailFields: [
        { key: 'label', label: 'Field' },
        { key: 'visible', label: 'Visible' },
      ],
      fields: [
        {
          key: 'incident_id',
          field: 'incident.incident.incident_id',
          label: 'ID',
          control: 'SearchInput',
          sortable: true,
          visible: true,
        },
        {
          key: 'severity',
          field: 'incident.incident.severity',
          label: 'Severity',
          sortable: true,
          visible: true,
        },
        {
          key: 'status',
          field: 'incident.incident.status',
          label: 'Status',
          control: 'SearchInput',
          sortable: true,
          thClass: 'incident-status',
          visible: true,
        },
        {
          key: 'description',
          field: 'incident.incident.description',
          label: 'Description',
          control: 'SearchInput',
          sortable: false,
          thClass: 'incident-description',
          visible: true,
        },
        {
          key: 'host_count',
          field: 'incident.incident.host_count',
          label: 'Hosts',
          sortable: true,
          visible: true,
        },
        {
          key: 'user_count',
          field: 'incident.incident.user_count',
          label: 'Users',
          sortable: true,
          visible: true,
        },
        {
          key: 'asset_count',
          field: 'incident.incident.asset_count',
          label: 'Assets',
          sortable: true,
          visible: true,
        },
        {
          key: 'netinfo_count',
          field: 'incident.incident.netinfo_count',
          label: 'Networks',
          sortable: true,
          visible: true,
        },
        {
          key: 'alerts',
          field: 'incident.incident.alerts',
          label: 'Alerts',
          thClass: 'incident-status',
          visible: true,
        },
        {
          key: 'creation_time',
          field: 'incident.incident.creation_time',
          label: 'Creation',
          thClass: 'incident-status',
          control: 'SearchDateTime',
          sortable: true,
          visible: true,
        },
        {
          key: 'modification_time',
          field: 'incident.incident.modification_time',
          label: 'Modification',
          control: 'SearchDateTime',
          thClass: 'incident-status',
          sortable: true,
          visible: true,
        },
        { key: 'action', sortable: false },
      ],
      allFields: [
        {
          key: 'incident_id',
          field: 'incident.incident.incident_id',
          label: 'ID',
          control: 'SearchInput',
          sortable: true,
          visible: true,
        },
        {
          key: 'severity',
          field: 'incident.incident.severity',
          label: 'Severity',
          sortable: true,
          visible: true,
        },
        {
          key: 'status',
          field: 'incident.incident.status',
          label: 'Status',
          control: 'SearchInput',
          sortable: true,
          thClass: 'incident-status',
          visible: true,
        },
        {
          key: 'description',
          field: 'incident.incident.description',
          label: 'Description',
          control: 'SearchInput',
          sortable: false,
          thClass: 'incident-description',
          visible: true,
        },
        {
          key: 'host_count',
          field: 'incident.incident.host_count',
          label: 'Hosts',
          sortable: true,
          visible: true,
        },
        {
          key: 'user_count',
          field: 'incident.incident.user_count',
          label: 'Users',
          sortable: true,
          visible: true,
        },
        {
          key: 'asset_count',
          field: 'incident.incident.asset_count',
          label: 'Assets',
          sortable: true,
          visible: true,
        },
        {
          key: 'netinfo_count',
          field: 'incident.incident.incident_id',
          label: 'Networks',
          sortable: true,
          visible: true,
        },
        {
          key: 'alerts',
          field: 'incident.incident.alerts',
          label: 'Alerts',
          thClass: 'incident-status',
          visible: true,
        },
        {
          key: 'creation_time',
          field: 'incident.incident.creation_time',
          label: 'Creation',
          thClass: 'incident-status',
          control: 'SearchDateTime',
          sortable: true,
          visible: true,
        },
        {
          key: 'modification_time',
          field: 'incident.incident.modification_time',
          label: 'Modification',
          thClass: 'incident-status',
          control: 'SearchDateTime',
          sortable: true,
          visible: true,
        },
      ],
      isBusy: true,
      searches: {},
      searchType: 'rawsearch',
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },
  computed: {
    rows() {
      return this.totalRows
    },
  },
  watch: {
    currentPage: {
      handler: function() {
        this.loadData(this.filter)
      },
    },
    perPage: {
      handler: function() {
        this.loadData(this.filter)
      },
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData(src = '') {
      let that = this
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const searchType = this.searchType
      const countURL =
        src.length < 1
          ? `${baseURL}${that.url}&count=yes`
          : `${baseURL}${that.url}&${searchType}=${src}&count=yes`

      axios
        .get(countURL)
        .then((response) => {
          that.totalRows = parseInt(response.data)
        })
        .catch(function() {})
      const dataURL =
        src.length < 1
          ? `${baseURL}${that.url}&page=${that.currentPage}&page_size=${
              that.perPage
            }&limit=${that.perPage}`
          : `${baseURL}${that.url}&page=${that.currentPage}&page_size=${
              that.perPage
            }&limit=${that.perPage}&${searchType}=${src}`
      axios
        .get(dataURL)
        .then((response) => {
          if (response.status === 200) {
            that.tableData = response.data.map(function(entry) {
              return {
                incident_id: entry.incident.incident.incident_id,
                severity: entry.incident.incident.severity,
                status: entry.incident.incident.status,
                description: entry.incident.incident.description,
                manual_severity: entry.incident.incident.manual_severity,
                alert_count: entry.incident.incident.alert_count,
                creation_time: new Date(
                  entry.incident.incident.creation_time['$date']
                ).toLocaleString(),
                modification_time: new Date(
                  entry.incident.incident.modification_time['$date']
                ).toLocaleString(),
                high_severity_alert_count:
                  entry.incident.incident.high_severity_alert_count !==
                  undefined
                    ? entry.incident.incident.high_severity_alert_count
                    : 0,
                med_severity_alert_count:
                  entry.incident.incident.med_severity_alert_count !== undefined
                    ? entry.incident.incident.med_severity_alert_count
                    : 0,
                low_severity_alert_count:
                  entry.incident.incident.low_severity_alert_count !== undefined
                    ? entry.incident.incident.low_severity_alert_count
                    : 0,
                host_count:
                  entry.incident.incident.host_count !== undefined
                    ? entry.incident.incident.host_count
                    : 0,
                user_count:
                  entry.incident.incident.user_count !== undefined
                    ? entry.incident.incident.user_count
                    : 0,
                asset_count:
                  entry.assets !== undefined && entry.assets.length > 0
                    ? entry.assets.length
                    : 0,
                netinfo_count:
                  entry.netinfo !== undefined && entry.netinfo.length > 0
                    ? entry.netinfo.length
                    : 0,
              }
            })
          }
          that.isBusy = false
        })
        .catch(function() {})
    },
    loadDetails(id) {
      const that = this
      that.incident = {}
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios
        .get(`${baseURL}/pan/xdr/incidents?incident_id=${id}&limit=1`)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.length > 0) {
              that.incident = response.data[0].incident
              that.incident_fa = response.data[0].incident.file_artifacts
              that.incident_na = response.data[0].incident.network_artifacts
              that.assets = response.data[0].assets || []
              that.netinfo = response.data[0].netinfo || []
            } else {
            }
          } else {
          }
        })

      setTimeout(function() {
        that.loadFileIndicators()
        that.loadNetworkIndicators()
      }, 1000)
    },
    modalIncidentDetailOk() {
      this.incident = {}
      this.incident_fa = {}
      this.incident_na = {}
      this.assets = []
    },
    loadFileIndicators() {
      const that = this
      if (
        this.incident_fa === undefined ||
        this.incident_fa.total_count === 0 ||
        this.incident_fa.data === undefined ||
        this.incident_fa.data.length === 0
      )
        return

      let hashes = this.incident_fa.data
        .map(function(entry) {
          return entry.file_sha256
        })
        .join(',')

      if (hashes.length === 0) return

      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios
        .get(`${baseURL}/pan/xdr/indicators?file_sha256=${hashes}&limit=100`)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.length > 0) that.indicatorsFile = response.data
          }
        })
    },
    loadNetworkIndicators() {
      const that = this
      if (
        this.incident_fa === undefined ||
        this.incident_fa.total_count === 0 ||
        this.incident_fa.data === undefined ||
        this.incident_fa.data.length === 0
      )
        return

      let remote_ips = this.incident_fa.data
        .map(function(entry) {
          return entry.remote_ip
        })
        .join(',')

      if (hashes.length === 0) return

      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios
        .get(`${baseURL}/pan/xdr/indicators?remote_ip=${remote_ips}&limit=100`)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.length > 0) that.indicatorsNet = response.data
          }
        })
    },
    showDetails(id) {
      if (id === undefined) return
      this.loadDetails(id)
      this.$refs['modal-details'].show()
    },
    doSearch() {
      let filter = this.filter
      if (filter.length !== undefined) {
        this.loadData(filter)
      }
    },
    configTable() {
      this.$refs['modal-table-config'].show()
    },
    toggleVisibleColumn(selected) {
      const that = this
      // const visible = !selected.visible
      const visible = selected.visible

      if (visible) {
        if (
          that.fields.filter((field) => field.label === selected.label)
            .length === 0
        ) {
          // if (that.fields.length > 1) that.fields.splice(that.fields.lenght - 2, 0, selected)
          let newFields = []
          that.allFields.forEach((af) => {
            if (af.label === selected.label) {
              newFields.push(selected)
            } else {
              if (
                that.fields.filter(
                  (field) => field.label === af.label && field.visible
                ).length > 0
              ) {
                newFields.push(af)
              }
            }
          })
          newFields.push({ key: 'action', sortable: false })
          that.fields = newFields
        }
      } else {
        if (
          that.fields.filter((field) => field.label === selected.label).length >
          0
        ) {
          let newFields = that.fields
          if (that.fields.length > 2)
            that.fields = newFields.filter(
              (field) => field.label !== selected.label
            )
        }
      }
    },
    generateFilterFromFields() {
      const that = this
      let filter = ''
      Object.keys(that.searches).map((key) => {
        console.log(key)
        if (that.searches[key] !== undefined && that.searches[key].length > 0) {
          // filter += `${key}:${that.searches[key]},`
          // filter += `${that.searches[key]}:${key},`
          filter += `${key}:${that.searches[key]},`
        }
      })
      return filter.substring(0, filter.length - 1)
    },
    doSearchInput() {
      this.searchType = 'mfsearch'
      this.fieldsFilter = this.generateFilterFromFields()
      if (this.fieldsFilter.length !== undefined) {
        this.loadData(this.fieldsFilter)
      }
    },
    fieldSearchChanged(desc, field, content) {
      this.searches[field] = content.trim()
    },
    datetimeSearchChanged(field, datetime) {
      this.searches[field] = datetime
    },
    async downloadCSVFull() {
      const that = this
      try {
        const baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
        const response = await axios.get(
          `${baseURL}/pan/xdr/incidents/csv?limit=2000&altorder=incident.incident.modification_time&direction=desc`,
          {
            responseType: 'blob',
          }
        )

        const blob = new Blob([response.data], {
          type: 'text/csv;charset=utf-8;',
        })

        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)

        link.setAttribute('href', url)
        link.setAttribute('download', 'pan_incidents.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Error downloading the CSV file:', error)
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="row mb-md-2">
      <div class="col-sm-6 col-md-6">
        <span>
          Incidents found:
          <b>
            {{ totalRows }}
          </b>
          at
          <b>
            {{ new Date().toLocaleString() }}
          </b>
        </span>
      </div>

      <div class="col-sm-6 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
          <label class="d-inline-flex align-items-center">
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Text to search..."
              class="form-control form-control-sm ml-2"
            />
            <b-button size="sm" variant="light" @click="doSearch">
              Search
            </b-button>
            <b-button size="sm" variant="light" @click="configTable">
              *
            </b-button>
          </label>
        </div>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        :items="tableData"
        :fields="fields"
        :busy="isBusy"
        responsive="sm"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :total-rows="totalRows"
        :pagination-options="{
          enabled: true,
        }"
      >
        <template v-if="showSearchByFields" v-slot:thead-top="data">
          <b-tr>
            <b-th v-for="field in fields">
              <template v-if="field.control === 'SearchInput'">
                <SearchInput
                  :desc="field.key"
                  :field="field.field"
                  text=""
                  @updated="fieldSearchChanged"
                />
              </template>
              <template v-else-if="field.control === 'SearchDateTime'">
                <SearchDateTime
                  :desc="field.key"
                  :field="field.field"
                  text=""
                  @updated="datetimeSearchChanged"
                />
              </template>
              <template v-if="field.key === 'action'">
                <b-button @click="doSearchInput">
                  Search by fields
                </b-button>
              </template>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:table-busy>
          <div class="text-center">
            <br /><br />
            <b-spinner class="align-middle" />
            <strong>&nbsp;&nbsp;Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(severity)="data">
          <template v-if="data.item.severity === 'low'">
            <feather type="alert-circle" class="icon-xs icon-dual-success" />
          </template>
          <template v-else-if="data.item.severity === 'medium'">
            <feather type="alert-triangle" class="icon-xs icon-dual-warning" />
          </template>
          <template v-else>
            <feather type="alert-octagon" class="icon-xs icon-dual-danger" />
          </template>
        </template>
        <template v-slot:cell(creation_time)="data">
          {{ data.item.creation_time }}
        </template>
        <template v-slot:cell(status)="data">
          <template v-if="data.item.status === 'new'">
            <span style="color:red;">
              <i class="uil uil-comment-plus font-size-15" />&nbsp;New
            </span>
          </template>
          <template v-else-if="data.item.status === 'closed'">
            <feather type="stop-circle" class="icon-xs icon-dual" />
            Closed
          </template>
          <template v-else-if="data.item.status === 'under_investigation'">
            <span style="color:blue;">
              <i class="uil uil-comment-search font-size-15" />&nbsp;Under
              Investigation
            </span>
          </template>
          <template v-else-if="data.item.status === 'resolved_threat_handled'">
            <span style="color:green;">
              <i class="uil uil-comment-shield font-size-15" />&nbsp;Resolved -
              Handled
            </span>
          </template>
          <template v-else-if="data.item.status === 'resolved_true_positive'">
            <span style="color:green;">
              <i class="uil uil-comment-slash font-size-15" />&nbsp;Resolved -
              T.Positive
            </span>
          </template>
          <template v-else-if="data.item.status === 'resolved_false_positive'">
            <span style="color:green;">
              <i class="uil uil-comment-slash font-size-15" />&nbsp;Resolved -
              F.Positive
            </span>
          </template>
          <template v-else-if="data.item.status === 'resolved_other'">
            <span style="color:green;">
              <i class="uil uil-comment-dots font-size-15" />&nbsp;Resolved -
              Other
            </span>
          </template>
        </template>
        <template v-slot:cell(alerts)="data">
          <span class="badge badge-secondary">
            {{ data.item.alert_count }}
          </span>
          <span>
            =
          </span>
          <span class="badge badge-danger">
            {{ data.item.high_severity_alert_count }}
          </span>
          <span>
            +
          </span>
          <span class="badge badge-warning">
            {{ data.item.med_severity_alert_count }}
          </span>
          <span>
            +
          </span>
          <span class="badge badge-success">
            {{ data.item.low_severity_alert_count }}
          </span>
        </template>
        <template v-slot:cell(action)="data">
          <b-dropdown
            right
            variant="white"
            class="align-self-center"
            toggle-class="p-0"
          >
            <template v-slot:button-content>
              <feather
                type="chevron-down"
                class="align-middle"
                style="height:12px !important;width:20px !important;"
              />
            </template>
            <b-dropdown-item
              class="notify-item"
              @click="showDetails(data.item.incident_id)"
            >
              <feather
                type="search"
                class="icon-dual icon-xs mr-2 align-middle"
              />
              <span>Details</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />&nbsp;entries
          </label>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <b-button
            v-if="showDownloadCSVButton"
            size="sm"
            variant="light"
            @click="downloadCSVFull"
          >
            Download CSV (max 2000 entries)
          </b-button>
        </div>
      </div>
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            />
          </ul>
        </div>
      </div>
    </div>
    <b-modal
      id="incident.incident_id"
      ref="modal-details"
      size="xl"
      title="Incident Details"
      :centered="true"
      :no-fade="true"
      ok-only
      @ok="modalIncidentDetailOk"
    >
      <div role="tablist" class="custom-accordionwitharrow">
        <template v-if="assets !== undefined && assets.length > 0">
          <a v-b-toggle.collapse-assets href="#" class="text-dark">
            <h5 class="mb-0">
              <feather type="chevron-down" class="align-middle" />
              Assets
              <span class="text-muted font-size-14">({{ assets.length }})</span>
            </h5>
          </a>
          <b-collapse id="collapse-assets" visible>
            <Assets :assets-data="assets" />
          </b-collapse>
        </template>

        <template v-if="netinfo !== undefined && netinfo.length > 0">
          <a v-b-toggle.collapse-assets href="#" class="text-dark">
            <h5 class="mb-0">
              <feather type="chevron-down" class="align-middle" />
              Involved Network Segments
              <span class="text-muted font-size-14"
                >({{ netinfo.length }})</span
              >
            </h5>
          </a>
          <b-collapse id="collapse-assets" visible>
            <NetInfos :netinfo-data="netinfo" />
          </b-collapse>
        </template>

        <template
          v-if="
            incident.alerts !== undefined && incident.alerts.total_count > 0
          "
        >
          <a v-b-toggle.collapse-alerts href="#" class="text-dark">
            <h5 class="mb-0">
              <feather type="chevron-down" class="align-middle" />
              Alerts
              <span class="text-muted font-size-14"
                >({{ incident.alerts.total_count }})</span
              >
            </h5>
          </a>
          <b-collapse id="collapse-alerts" visible>
            <Alerts :alerts-data="incident.alerts.data" />
          </b-collapse>
        </template>

        <template
          v-if="indicatorsNet !== undefined && indicatorsNet.length > 0"
        >
          <b-card no-body class="mb-1 border shadow-none">
            <b-card-header header-tag="header" role="tab">
              <a href="javascript: void(0);" class="text-black">
                <h5 v-b-toggle.accordion-2 class="m-0 font-size-16"
                  >Network Artifacts</h5
                >
              </a>
            </b-card-header>
            <b-collapse
              id="accordion-2"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text v-for="nartifacts in indicatorsNet">
                  {{ nartifacts }}
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </template>

        <template
          v-if="indicatorsFile !== undefined && indicatorsFile.length > 0"
        >
          <a v-b-toggle.collapse-files href="#" class="text-dark">
            <h5 class="mb-0">
              <feather type="chevron-down" class="align-middle" />
              Files
              <span class="text-muted font-size-14"
                >({{ indicatorsFile.length }})</span
              >
            </h5>
          </a>
          <b-collapse id="collapse-files">
            <Files :indicators-file="indicatorsFile" />
          </b-collapse>
        </template>
      </div>
    </b-modal>
    <b-modal
      id="table_config"
      ref="modal-table-config"
      size="xl"
      title="Events Table Config"
      :centered="true"
      :no-fade="true"
      ok-only
      @ok="modalTableDetaillOk"
    >
      <b-table :items="allFields" :fields="tableDetailFields" responsive="sm">
        <template v-slot:cell(visible)="data">
          <template v-for="field in allFields">
            <template v-if="data.item.label === field.label">
              <b-form-checkbox
                v-model="field.visible"
                name="check-button"
                switch
                @change="toggleVisibleColumn(data.item, field)"
              />
            </template>
          </template>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<style>
.incident-status {
  width: 15%;
}
.incident-description {
  width: 35%;
}
</style>
